import {
	Box,
	Typography,
	Spacer,
	AlternativeStylesPropertiesTypography,
	LinkProps,
	Tooltip,
	TooltipRef,
	BoxRef,
	Link,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { rem } from '@helpers';
import React, { ReactElement } from 'react';
import { useSummaryNextStepsItemHelper } from './summaryNextStepsItem.helper';

type TypographyStyles = React.CSSProperties & AlternativeStylesPropertiesTypography;

export interface SummaryNextStepsItemProps {
	title: string;
	description: string | React.ReactNode;
	mainIcon: ReactElement;
	link?: string;
	linkText?: string;
	linkIcon?: ReactElement;
	linkProps?: LinkProps;
	linkIconTooltipText?: string;
	inlineLink?: boolean;
	linkOnPress?: () => void;
}

export const SummaryNextStepsItem: React.FC<SummaryNextStepsItemProps> = ({
	title,
	description,
	mainIcon,
	linkText,
	linkIcon,
	link,
	inlineLink,
	linkProps,
	linkIconTooltipText,
	linkOnPress,
}) => {
	const anchorRef = React.useRef<BoxRef>(null);
	const tooltipRef = React.useRef<TooltipRef>(null);
	const { MainIcon } = useSummaryNextStepsItemHelper(mainIcon, linkIcon);

	return (
		<>
			<Tooltip
				placement="bottom"
				description={{ text: linkIconTooltipText || '' }}
				closeOnPressOutside={false}
				ref={tooltipRef}
				anchorRef={anchorRef}
			/>
			<Box styles={{ padding: rem(16, 32), alignItems: 'flex-start' }}>
				{MainIcon}
				<Box styles={{ flexDirection: 'column' }}>
					<Typography appearance="subtitle-100-04">{title}</Typography>
					<Spacer vertical={rem(8)} />
					<div>
						{typeof description === 'string' ? (
							<Typography
								appearance="body-100-02"
								colorsLevel="neutralPrimary"
								alternativeStyleProperties={
									!inlineLink ? ({ display: 'block' } as TypographyStyles) : undefined
								}
							>
								{description}
							</Typography>
						) : (
							description
						)}

						{!inlineLink && <Spacer vertical={rem(8)} />}
						{(link || linkOnPress) && (
							<div style={{ display: 'inline', verticalAlign: linkText ? 'baseline' : 'middle' }}>
								<Link
									middleContent={linkText as string}
									{...linkProps}
									link={link}
									onPress={linkOnPress}
								/>
							</div>
						)}
					</div>
				</Box>
			</Box>
		</>
	);
};
